<template>
    <CustomHeader :text="$t('activityName.active_tresure_chest')" />
    <div class="mainContainer">
        <div class="banner">
            <img v-if="dataSet.flatIcon" :src="dataSet.flatIcon" alt="">
            <img v-else src="@/assets/activeBonus/active_chest_top_banner.png" alt="">
            <div class="chestBoard">
                <img src="@/assets/themeThree/active_chest_card.png" alt="">
                <div class="amountCard"> <span> R$ {{ dataSet.amount }}</span></div>
                <div class="buttonImg">
                    <img v-if="dataSet.amount <= 0" src="@/assets/activeBonus/active_chest_button_0.png" alt="">
                    <img v-else src="@/assets/activeBonus/active_chest_button_1.png" alt="" @click="chestClaim">
                </div>
            </div>
        </div>
        <div class="detailsBorad">
            <img style="border-radius: 10px;" src="@/assets/themeThree/active_chest_share_bg.png" alt="">
            <van-row class="linkCard">
                <van-col span="19" style="display: flex; align-items: center;">{{ dataSet.copyLink }}</van-col>
                <van-col span="5" class="copyButtonContainer">
                    <div class="copyButton" @click="copyValue(dataSet.copyLink)">{{ $t('common.copy')
                    }}</div>
                </van-col>
            </van-row>

            <van-row class="shareBtnCard">
                <van-col v-for="(item, index) in shareList" :key="index" span="4" class="shareBtn">
                    <img :src="item.img" alt="" @click="goToShare">
                    <div class="shareText">{{ item.name }}</div>
                </van-col>
            </van-row>

            <van-row class="inviteTextCard">
                <van-col span="16" class="textRight"> {{ $t('activity.inviteAssets') }}</van-col>
                <van-col span="8">
                    <div class="textLeft" @click="showRules">
                        {{ $t('activity.viewRules') }}
                        <img src="@/assets/activeBonus/active_chest_rules.png" alt="">
                    </div>
                </van-col>
            </van-row>
        </div>

        <div class="rewardCard">
            <div class="topRoller">
                <img src="@/assets/activeBonus/active_chest_card_side.png" alt="">
            </div>
            <van-row class="rollerTitleRow">
                <van-col span="16" class="rollerTitle">
                    <img src="@/assets/themeThree/active_chest_card_title.png" alt="">
                </van-col>
                <van-col span="8" class="rollerBtn">
                    <div class="inviteBtn" @click="goToChestUser">
                        <div style="display: flex;justify-content: left; align-items: center;">
                            <div class="inviteTextCount">{{ dataSet.userCount }}</div>
                            <div class="inviteText">{{ $t('common.pepole') }}</div>
                        </div>
                        <div style="display: flex;justify-content: right;"> <img
                                src="@/assets/themetwo/active_chest_arrow.png" alt=""></div>
                    </div>
                </van-col>
            </van-row>

            <van-row class="cardRow">
                <div v-for="(value, index) in zigzagReordered" :key="index" class="cardCol" style="width: 25%;">
                    <div v-if="!value.isNullObject">
                        <div class="giftContainer">
                            <div class="imageContainer">
                                <img v-if="value.received == 1" src="@/assets/activeBonus/active_chest_inprogress.png"
                                    alt="">
                                <img v-else src="@/assets/activeBonus/active_chest_notstarted.png" alt="">
                                <div class="ratioText"><span>{{ value.received == 1 ? value.active_users :
                                    dataSet.userCount }}</span> / {{
                                            value.active_users }}</div>
                            </div>
                            <div class="amountText"
                                :style="{ color: value.received == 1 ? '#D242CD' : '', fontWeight: value.received == 1 ? '600' : '', }">
                                R$ <span
                                    :style="{ color: value.received == 1 ? '#D242CD' : '', fontWeight: value.received == 1 ? '600' : '', }">{{
                                        value.reward_for_chest }}</span></div>
                        </div>
                        <div class="arrowImg" v-if="value.side == 'left' && !value.turnDown && !value.isLast">
                            <img src="@/assets/themeThree/active_chest_next.png" alt="">
                        </div>
                        <div class="arrowImgRight" v-if="value.side == 'right' && (value.displayIndex < 3)">
                            <img src="@/assets/themeThree/active_chest_next.png" alt="">
                        </div>
                        <div class="arrowDownImg" v-if="value.turnDown && !value.isLast">
                            <img src="@/assets/themeThree/active_chest_next.png" alt="">
                        </div>
                    </div>

                </div>
            </van-row>


            <div class="bottomRoller">
                <img src="@/assets/activeBonus/active_chest_card_side.png" alt="">
            </div>
        </div>

    </div>
    <RulePopup ref="ruleRef" />
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import RulePopup from './components/rulePopup.vue';
import { toZigZagWithFlagsAdvance } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { ActiveChestData, SHARE_LIST } from '@/view/activeChest/supportScript';

const ruleRef = ref()
const shareList = ref(SHARE_LIST)

const props = defineProps<{
    dataSet: ActiveChestData
}>()
const emits = defineEmits(['copyValue', 'chestClaim', 'goToShare', 'goToChestUser'])

const zigzagReordered = computed<any>(() => {
    return toZigZagWithFlagsAdvance(props.dataSet.rewardList, 4);
})

const showRules = () => {
    ruleRef.value.open(props.dataSet.activityIntro)
}
const copyValue = (value: any) => {
    emits('copyValue', value)
}
const chestClaim = () => {
    emits('chestClaim')
}
const goToShare = async () => {
    emits('goToShare')
}

const goToChestUser = () => {
    emits('goToChestUser')
}

</script>
<style scoped>
.mainContainer {
    padding: 50px 0;
    min-height: 100vh;
    background: #090F1F;
}

.banner {
    position: relative;
}

.banner img {
    width: 100%;
}

.chestBoard {
    position: absolute;
    bottom: 0;
    margin-bottom: -12%;
}

.amountCard {
    position: absolute;
    top: 35%;
    width: 100%;
    display: flex;
    justify-content: center;
}

.amountCard span {
    min-width: 150px;
    background: rgba(0, 0, 0, 0.50);
    border-radius: 5px;
    text-align: center;
    color: #FFEE00;
    font-size: 22px;
    text-shadow: 2px 2px 0 #0C0000, -2px 2px 0 #0C0000, 2px -2px 0 #0C0000, -2px -2px 0 #0C0000;
    padding: 5px;
}

.buttonImg {
    position: absolute;
    top: 75%;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 1;
}

.buttonImg img {
    width: 35%;
}

.detailsBorad {
    position: relative;
    width: 100%;
    padding: 27.5% 5% 0;
}

.detailsBorad img {
    width: 90%;
}

.linkCard {
    position: absolute;
    border-radius: 5px;
    padding: 2%;
    background: rgba(0, 0, 0, 0.50);
    /* border: 1px solid #ffd700; */
    color: #ffd700;
    top: 45%;
    left: 10%;
    right: 20%;
    font-size: 8px;
}

.copyButtonContainer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.copyButton {
    background: linear-gradient(0deg, rgb(242, 147, 16) 0%, rgb(252, 182, 89) 100%);
    border-radius: 5px;
    color: #fff;
    font-size: 10px;
    padding: 15%;
    width: 100%;
    font-weight: bold;
    text-align: center;
}

.shareBtnCard {
    position: absolute;
    border-radius: 5px;
    padding: 3% 0;
    top: 65%;
    left: 10%;
    right: 20%;
}

.shareBtn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.shareBtn img {
    width: 50%;
    border-radius: 30px;
}

.shareText {
    color: #fff;
    font-size: 8px;
    padding-top: 2px;
}

.inviteTextCard {
    position: absolute;
    border-radius: 5px;
    padding: 3% 0;
    bottom: 2%;
    left: 10%;
    right: 20%;
}

.textRight {
    color: #fff;
    font-size: 10px;
}

.textLeft {
    color: #FFAF00;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.textLeft img {
    width: 15%;
    padding-left: 5px;
}

.rewardCard {
    position: relative;
    margin: 10% 5% 0;
}

.topRoller img {
    position: absolute;
    top: -7%;
    width: 100%;
}

.rollerTitleRow {
    padding: 0px 10%;
    position: absolute;
    top: -8%;
    left: 0;
    right: 0;
}

.rollerTitle {
    display: flex;
    align-items: center;
}

.rollerTitle img {
    width: 70%;
}

.rollerBtn {
    display: flex;
    align-items: center;
    justify-content: right;
}

.inviteBtn {
    display: flex;
    align-items: center;
    justify-content: right;
    border-radius: 30px;
    background: #734725;
    border: 1px solid #ffa600;
    color: #fff;
    padding-left: 5px;
    padding-right: 1px;
}

.inviteBtn img {
    width: 50%;
}

.inviteTextCount {
    font-size: 10px;
    font-weight: bold;
    padding: 5%;
}

.inviteText {
    font-size: 10px;
    padding: 15% 5%;
}

.bottomRoller img {
    position: absolute;
    bottom: -7%;
    width: 100%;
    rotate: 180deg;
}

.giftContainer {
    padding: 10px 0;
}

.giftContainer img {
    width: 80%;
}

.imageContainer {
    position: relative;
}

.ratioText {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: center;
    color: #fff;
    padding: 5px;
    font-size: 6px;
}

.ratioText span {
    color: #FFEE00;
}

.amountText {
    font-size: 10px;
    text-align: center;
    padding-bottom: 15%;
    color: gray;
}

.amountText span {
    color: #000;
}

.cardRow {
    background: url('@/assets/activeBonus/active_chest_card_bg.png');
    background-size: contain;
    width: 80%;
    margin: 0 5%;
    padding: 10% 5%;
}

.cardRow img {
    width: 90%;
}

.cardCol {
    position: relative;
    display: flex;

}

.arrowImg img {
    width: 30%;
    position: absolute;
    top: 30%;
    right: -10%;
    z-index: 1;
}

.arrowImgRight img {
    width: 30%;
    position: absolute;
    top: 30%;
    right: -10%;
    rotate: 180deg;
    z-index: 1;
}

.arrowDownImg img {
    width: 30%;
    position: absolute;
    bottom: -12.5px;
    right: 40%;
    rotate: 90deg;
}

@media (min-width:350px) {
    .textRight {
        font-size: 12px;
    }

    .textLeft {
        font-size: 12px;
    }

    .inviteTextCount {
        font-size: 12px;
    }

    .inviteText {
        font-size: 12px;
    }

    .rollerTitleRow {
        top: -5%;
    }

    .linkCard {
        font-size: 11px;
    }

    .copyButton {
        font-size: 12px;
    }

    .shareText {
        font-size: 10px;
    }

    .amountText {
        font-size: 12px;
    }

    .ratioText {
        font-size: 9px;
    }
}

@media (min-width: 600px) {
    .textRight {
        font-size: 14px;
    }

    .textLeft {
        font-size: 14px;
    }

    .inviteTextCount {
        font-size: 12px;
    }

    .inviteText {
        font-size: 12px;
    }

    .rollerTitleRow {
        top: -5%;
    }

    .linkCard {
        font-size: 12px;
    }

    .copyButton {
        font-size: 13px;
    }

    .shareText {
        font-size: 10px;
    }

    .amountText {
        font-size: 13px;
    }

    .ratioText {
        font-size: 9px;
    }
}

@media (min-width: 1920px) {
    .textRight {
        font-size: 15px;
    }

    .textLeft {
        font-size: 15px;
    }

    .inviteTextCount {
        font-size: 13px;
    }

    .inviteText {
        font-size: 13px;
    }

    .rollerTitleRow {
        top: -6%;
    }

    .linkCard {
        font-size: 15px;
    }

    .copyButton {
        font-size: 13px;
    }

    .shareText {
        font-size: 10px;
    }

    .amountText {
        font-size: 14px;
    }

    .ratioText {
        font-size: 9px;
    }
}
</style>